<template>
    <div style="display: flex; flex-direction:column; align-items:center; padding:20px 10px">
        <a-button type="primary" shape="round" class="printBtn center-flex"
            :icon="h(PrinterOutlined)" @click="printPage"
        >
            Imprimir
        </a-button>
        <form style="width:100%; text-align:center">
            <img src="/img/auto.png" width="100%" alt="imagem secretaria da fazenda/financas">

            <a-card size="small" style="margin: 10px 0">
                <template #title>
                    <span class="label">Dados Cadastrais do Imóvel</span>
                </template>

                <div class="label">Matrícula:<span class="content"> {{ imovel.matricula }} </span></div>
                <div class="label">IDBQL:<span class="content"> {{ imovel.idbql }} </span></div>
                <div class="label">Setor:<span class="content"> {{ imovel.setor }} </span></div>
                <div class="label">Quadra:<span class="content"> {{ imovel.quadra }} </span></div>
                <div class="label">Lote:<span class="content"> {{ imovel.lote }} </span></div>
                <br />
                <div class="label">
                    End:
                    <span class="content">
                        {{ imovel.endereco }}
                    </span>
                </div>
                <div class="label">Propriétario:<span class="content"> {{ imovel.proprietario }} </span></div>
            </a-card>

            <a-card size="small" style="margin: 10px 0">
                <table class="content">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>Dados do Geo</th>
                            <th>Dados do Sistema</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>Área Lote</th>
                            <td>-</td>
                            <td>{{ !isNaN(parseFloat(lote.areaGeom)) ? parseFloat(lote.areaGeom).toFixed(2) : lote.areaGeom }}</td>
                            <td>{{ !isNaN(parseFloat(lote.areaSist)) ? parseFloat(lote.areaSist).toFixed(2) : lote.areaSist }}</td>
                        </tr>
                        <tr v-for="edif in edificacoes" :key="edif.id">
                            <th>Área Edificada</th>
                            <td>{{ edif.idcons }}</td>
                            <td>{{ !isNaN(parseFloat(edif.areaGeom)) ? parseFloat(edif.areaGeom).toFixed(2) : edif.areaGeom }}</td>
                            <td>{{ !isNaN(parseFloat(edif.areaSist)) ? parseFloat(edif.areaSist).toFixed(2) : edif.areaSist }}</td>
                        </tr>
                        <tr>
                            <th>Total das edificações</th>
                            <td>-</td>
                            <td>{{ totalAreaGeom.toFixed(2) }}</td>
                            <td>{{ totalAreaSist.toFixed(2) }}</td>
                        </tr>
                    </tbody>
                </table>
            </a-card>

            <a-card size="small" style="margin: 5px 0; break-after:page">
                <template #title>
                    <span class="label">Lote</span>
                </template>

                <iframe height="420px" width="100%" :src="`func/not_planta?id=${id}&type=lote`" allowfullscreen />
            </a-card>

            <a-card size="small" style="margin: 5px 0">
                <template #title>
                    <span class="label">Quadra</span>
                </template>

                <iframe height="420px" width="100%" :src="`func/not_planta?id=${id}&type=quadra`" allowfullscreen />
            </a-card>
        </form>
    </div>
</template>

<script setup>
import {h, onMounted, ref} from "vue";
import {PrinterOutlined} from "@ant-design/icons-vue";

const props = defineProps(['dados', 'dadosGeral', 'edifGeo', 'cadGeral', 'cadLote']);
const id = new URLSearchParams(window.location.search).get('id')
const imovel = ref({})
const lote = ref({})
const edificacoes = ref([])
const totalAreaGeom = ref(0)
const totalAreaSist = ref(0)
const printPage = () => window.print()

onMounted(() => {
    const dados0 = Array.isArray(props.dados) ? props.dados[0] : null
    if (!dados0) return

    const edificacoesSist = Array.isArray(props.dadosGeral?.edificacoes) ? props.dadosGeral.edificacoes : []
    const numeroEndereco =
        edificacoesSist?.[0]?.unidades?.[0]?.numero ??
        dados0?.z01_numero ??
        '--'

    imovel.value = {
        matricula: dados0['j01_matric'],
        idbql: dados0['j01_idbql'],
        setor: dados0['j34_setor'],
        quadra: dados0['j34_quadra'],
        lote: dados0['j34_lote'],
        // Em algumas matrículas o `dadosGeral.edificacoes` pode vir vazio; não pode quebrar a tela.
        endereco: `${dados0['j14_nome']} - ${numeroEndereco}/${dados0['bairro']}`,
        proprietario: dados0['z01_nomecomple']
    }

    const cadLote0 = Array.isArray(props.cadLote) ? props.cadLote[0] : null
    const areaGeomLote = cadLote0?.area_geometrica
    const areaSistLote = props.dadosGeral?.lote?.area

    lote.value = {
        areaGeom: areaGeomLote !== undefined && areaGeomLote !== null && areaGeomLote !== ''
            ? parseFloat(areaGeomLote).toFixed(2)
            : '--',
        areaSist: areaSistLote !== undefined && areaSistLote !== null && areaSistLote !== ''
            ? parseFloat(areaSistLote).toFixed(2)
            : '--'
    }

    // Usar as edificações do geo (mesmas que aparecem no mapa)
    // Cada geometria é exibida individualmente, sem agrupar
    const edifGeoArr = Array.isArray(props.edifGeo)
        ? props.edifGeo
        : (props.edifGeo ? Object.values(props.edifGeo) : [])

    if (edifGeoArr.length > 0) {
        const temMultiplasEdif = edifGeoArr.length > 1
        const cadGeralArr = Array.isArray(props.cadGeral) ? props.cadGeral : []
        
        // Buscar área do sistema para todas as edificações
        const areasEncontradas = []
        edifGeoArr.forEach((edifGeo) => {
            const cadGeralItem = cadGeralArr.find(obj => String(obj['j39_idcons']) === String(edifGeo['j39_idcons']))
            const dadosGeralEdif = edificacoesSist.find(edif =>
                edif?.unidades?.some(und =>
                    String(und?.construcao) === String(edifGeo?.j39_idcons) &&
                    String(und?.matricula) === String(imovel.value.matricula)
                )
            )
            
            if (dadosGeralEdif) {
                const unidade = dadosGeralEdif['unidades']?.find(und => 
                    String(und['construcao']) === String(edifGeo['j39_idcons']) && String(und['matricula']) === String(imovel.value.matricula)
                )
                if (unidade && !cadGeralItem?.['j39_dtdemo']) {
                    areasEncontradas.push({
                        gid: edifGeo['gid'],
                        area: unidade['area']
                    })
                }
            }
        })
        
        // Verificar se é área somada: múltiplas geometrias mas todas com a mesma área (ou apenas uma área encontrada)
        let areaSistSomada = null
        const areasUnicas = [...new Set(areasEncontradas.map(a => a.area))]
        const ehAreaSomada = temMultiplasEdif && (areasUnicas.length === 1 || areasEncontradas.length === 1)
        
        if (ehAreaSomada && areasEncontradas.length > 0) {
            areaSistSomada = areasEncontradas[0].area
        }
        
        edifGeoArr.forEach((edifGeo, index) => {
            let areaSist = '--'
            
            if (areaSistSomada !== null) {
                // Área somada: mostrar apenas na primeira linha
                if (index === 0) {
                    areaSist = areaSistSomada
                } else {
                    areaSist = '-'
                }
            } else {
                // Área específica para cada edificação
                const areaEncontrada = areasEncontradas.find(a => a.gid === edifGeo['gid'])
                if (areaEncontrada) {
                    areaSist = areaEncontrada.area
                }
            }

            totalAreaGeom.value += parseFloat(edifGeo['area_geometrica']) || 0

            const edif = edificacoes.value.find(edif => edif.idcons === edifGeo['j39_idcons'])

            if (!!edif &&  !!edifGeo['area_geometrica']) {
                edif.areaGeom = (Number(edif.areaGeom) + parseFloat(edifGeo['area_geometrica'])).toFixed(2)
                return
            }

            totalAreaSist.value += parseFloat(areaSist) || 0

            edificacoes.value.push({
                id: edifGeo['gid'] || edifGeo['j39_idcons'], // gid para key única
                idcons: edifGeo['j39_idcons'], // ID da construção para exibir
                areaGeom: edifGeo['area_geometrica'] ? parseFloat(edifGeo['area_geometrica']).toFixed(2) : '--',
                areaSist: areaSist
            })
        })
    }
})
</script>

<style scoped>
.printBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    background-color: #008B79;
    margin-bottom: 5px
}

@media print {
    .printBtn {
        visibility: hidden;
    }
}

.content {
    font-weight: normal;
    color: #1B5A9D;
    margin-left: 4px;
}

.label {
    display: inline-block;
    color: #008B79;
    font-weight: bold;
    line-height: 2em;
    margin-left: 7px;
    margin-right: 7px
}


table {
    width: 100%;
    border-collapse: collapse;
    border: 2px solid #8C8C8CFF;
    font-family: sans-serif;
    font-size: 0.8rem;
    letter-spacing: 1px;
}

thead,
th {
    background-color: #008B7920;
}

th,
td {
    border: 1px solid #A0A0A0FF;
    padding: 8px 10px;
}

tbody > tr:nth-of-type(even) {
    background-color: #EDEEF2FF;
}
</style>